// JP cm → EU size conversion for footwear
export const footwearJpToEu: Record<string, string> = {
  "20": "35",
  "20.5": "35.5",
  "21": "36",
  "21.5": "36.5",
  "22": "37",
  "22.5": "37.5",
  "23": "38",
  "23.5": "38.5",
  "24": "39",
  "24.5": "39.5",
  "25": "40",
  "25.5": "40.5",
  "26": "41",
  "26.5": "41.5",
  "27": "42",
  "27.5": "42.5",
  "28": "43",
  "28.5": "43.5",
  "29": "44",
  "29.5": "44.5",
  "30": "45",
  "30.5": "45.5",
  "31": "46",
  "31.5": "46.5",
  "32": "47",
  "32.5": "47.5",
  "33": "48",
  "33.5": "48.5",
  "34": "49",
};

export const sizeOptions = [
  // {
  //   label: "All",
  //   value: "all",
  //   options: [
  //     "XXXXXS",
  //     "XXXXS",
  //     "XXXS",
  //     "XXS",
  //     "XS",
  //     "S",
  //     "M",
  //     "L",
  //     "XL",
  //     "XXL",
  //     "XXXL",
  //     "XXXXL",
  //     "XXXXXL",
  //     "XXXXXXL",
  //     "XXXXXXXL",
  //   ],
  // },
  {
    id: 1,
    label: "Tops",
    value: "tops",
    options: [
      "XXXXXS",
      "XXXXS",
      "XXXS",
      "XXS",
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "XXL",
      "XXXL",
      "XXXXL",
      "XXXXXL",
      "XXXXXXL",
      "XXXXXXXL",
    ],
  },
  {
    id: 2,
    label: "Bottoms",
    value: "bottoms",
    options: [
      "XXXXXS",
      "XXXXS",
      "XXXS",
      "XXS",
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "XXL",
      "XXXL",
      "XXXXL",
      "XXXXXL",
      "XXXXXXL",
      "XXXXXXXL",
    ],
  },
  {
    id: 3,
    label: "Dresses",
    value: "dresses",
    options: [
      "XXXXXS",
      "XXXXS",
      "XXXS",
      "XXS",
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "XXL",
      "XXXL",
      "XXXXL",
      "XXXXXL",
      "XXXXXXL",
      "XXXXXXXL",
    ],
  },
  {
    id: 4,
    label: "Outerwear",
    value: "outerwear",
    options: [
      "XXXXXS",
      "XXXXS",
      "XXXS",
      "XXS",
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "XXL",
      "XXXL",
      "XXXXL",
      "XXXXXL",
      "XXXXXXL",
      "XXXXXXXL",
    ],
  },
  {
    id: 5,
    label: "Footwear",
    value: "footwear",
    options: [
      "20",
      "20.5",
      "21",
      "21.5",
      "22",
      "22.5",
      "23",
      "23.5",
      "24",
      "24.5",
      "25",
      "25.5",
      "26",
      "26.5",
      "27",
      "27.5",
      "28",
      "28.5",
      "29",
      "29.5",
      "30",
      "30.5",
      "31",
      "31.5",
      "32",
      "32.5",
      "33",
      "33.5",
      "34",
    ],
  },
];
